import React from 'react'
import { useTranslation } from 'react-i18next'

import MaintenanceScreenImage from '@/assets/NewSearchErrorImage.svg'
import { Feedback } from '@/components/Feedback/Feedback'
import { WeScreen } from '@/components/WeScreen/WeScreen'

export const Maintenance = () => {
  const { t } = useTranslation()

  return (
    <WeScreen useHeader={false}>
      <Feedback
        title={t('maintenance.title')}
        message={t('maintenance.message')}
        image={MaintenanceScreenImage}
      />
    </WeScreen>
  )
}
